import Link from "next/link";
import { Button, Card, Container } from "@chef/components";
import { DeliveryInterval, BRAND_PATHS } from "@chef/constants";
import { formatDate } from "@chef/helpers";
import { Success } from "@chef/icons/symbol";
import { PageLoader } from "@chef/smart-components";
import { useBillingQuery, useCalendarQuery } from "@chef/state-management";
import { getBasketDataFromCalendar } from "@chef/state-management/helpers";
import { intl } from "./WeekEditorRestartedBilling.Intl";

interface WeekEditorRestartedBillingProps {
  week: number;
  year: number;
}
export const WeekEditorRestartedBilling = ({
  week,
  year,
}: WeekEditorRestartedBillingProps) => {
  const { data: { billing } = {}, isLoading: isLoadingBilling } =
    useBillingQuery();

  const { data: { calendar } = {}, isLoading: isLoadingCalendar } =
    useCalendarQuery({ week, year, range: 1 });

  const isLoading = isLoadingCalendar || isLoadingBilling;

  if (isLoading) {
    return <PageLoader />;
  }

  const defaultBasket = billing?.baskets.find((b) => b.default);
  const deliveryInterval = defaultBasket?.deliveryInterval as DeliveryInterval;

  const basketData = getBasketDataFromCalendar({
    calendar,
    week,
    year,
  });

  const deliveryDate =
    basketData?.shippingDetails.plannedDeliveryInformation.deliveryDate;

  const deliveryDateString =
    deliveryDate && formatDate(deliveryDate, "yyyy-MM-dd");

  return (
    <Container outerClassName="flex justify-center items-center bg-background -mt-15 min-h-screen">
      <Card className="max-w-lg text-center">
        <Success className="w-20 h-20" />

        <h1 className="mt-6 text-xl md:text-2xl">
          {intl.FIRST_DELIVERY_MESSAGE}
        </h1>

        <div className="p-4 mt-4 text-center bg-informationBG">
          {deliveryDateString}
        </div>

        <div className="mt-4">
          {intl.YOUR_MEALBOX_GETS_DELIVERED(deliveryInterval)}
        </div>

        <div className="mt-4">{intl.CHANGE_DELIVERY_INTERVAL_INFO}</div>

        <Link
          href={BRAND_PATHS.WEEK_EDITOR_CONFIRMATION_PAGE({ week, year })}
          passHref
          legacyBehavior
        >
          <Button className="mt-6" primary>
            {intl.CONFIRM_TEXT}
          </Button>
        </Link>
      </Card>
    </Container>
  );
};
